import { MODAL_SHOW, MODAL_TYPE_ERROR } from "../constants/constants";
import { ERROR_SOMETHING_WENT_WRONG, ERROR_HEADER } from "../constants/copy";
import { showMaintenanceScreen, hideMaintenanceScreen } from "./fullscreenActions";
import { store } from "../store/configureStore";
import { ERROR_WHITELIST } from "../constants/errorWhiteList";

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const postToController = async (dispatch, endpoint, jsonBody, returnResponseOnError = false): Promise<any> => {
    let getState = store.getState();
    let result = "";
    var finalEndpoint = endpoint;
    if (isLocalhost) {
        finalEndpoint = '../' + endpoint;
    }
    let token = "Empty";
    // @ts-ignore
    if ((getState.firebase?.auth?.stsTokenManager?.accessToken ?? "") !== "") {
        // @ts-ignore
        token = getState.firebase?.auth?.stsTokenManager?.accessToken
    }
    await fetch(finalEndpoint, {
        method: 'POST',
        headers: {
            'Accept': 'application/json; charset=utf-8',
            'Content-Type': 'application/json;charset=UTF-8',
            'firebaseToken': token,
        },
        body: jsonBody,

    })
        .then(async (resp) => {
            var response = await resp.json();
            if (response.maintenance) {
                dispatch(showMaintenanceScreen());
                poll(dispatch);
            }
            if (response == null || !response.success) {
                if (returnResponseOnError) {
                    result = response;
                } else {
                    result = "Failure";
                }
                try {
                    // @ts-ignore
                    var loggedIn = getState.auth.loggedIn;
                    if (loggedIn === true) {
                        var message = ERROR_SOMETHING_WENT_WRONG;
                        if (response.message !== null && response.message !== "") {
                            message = response.message;
                        }
                        if (message && message !== "") {
                            dispatch({
                                type: MODAL_SHOW,
                                modalProps: {
                                    type: MODAL_TYPE_ERROR,
                                    header: ERROR_HEADER,
                                    body: message,
                                }
                            });
                        }
                    }
                } catch (err) {
                    logErrorToDatabase("An error occurred and the user was not notified because of another error: '" + err + "' loggedIn: " + loggedIn);
                }
            }
            else {
                result = response.data;
            }
        }).catch(async (err) => {
            await logErrorToDatabase(err);
        });
    return result;
}

export const getFromController = async (dispatch, endpoint, jsonBody): Promise<any> => {
    let result = "";
    var finalEndpoint = endpoint;
    if (isLocalhost) {
        finalEndpoint = '../' + endpoint;
    }
    await fetch(finalEndpoint, {
        method: 'GET',
        headers: {
            'Accept': 'application/json; charset=utf-8',
            'Content-Type': 'application/json;charset=UTF-8'
        },
        body: jsonBody,
    })
        .then(async (resp) => {
            var response = await resp.json();

            if (response.maintenance) {
                dispatch(showMaintenanceScreen());
                poll(dispatch);
            }

            if (!response.success) {
                var message = ERROR_SOMETHING_WENT_WRONG;
                if (response.message !== null && response.message !== "") {
                    message = response.message;
                }
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: message,
                    }
                });
            }
            else {
                result = response.data;
            }
        }).catch(async (err) => {
            await logErrorToDatabase(err);
        });
    return result;
}

async function pingService(dispatch): Promise<boolean> {
    var result = true;
    var endpoint = 'Ping';
    var finalEndpoint = endpoint;
    if (isLocalhost) {
        finalEndpoint = '../' + endpoint;
    }
    await fetch(finalEndpoint, {
        method: 'POST',
        headers: {
            'Accept': 'application/json; charset=utf-8',
            'Content-Type': 'application/json;charset=UTF-8'
        },
        body: null,
    }).then(async (resp) => {
        let response = await resp.json();
        result = !response.maintenance;
    }).catch(() => {
        setTimeout(() => poll(dispatch), 1000);
    });
    return result;
}

async function poll(dispatch) {
    var isAlive = await pingService(dispatch);
    if (isAlive) {
        dispatch(hideMaintenanceScreen());
    } else {
        setTimeout(() => poll(dispatch), 5000);
    }
}

export const logInfoToDatabase = async (message: string) => {
    if (isLocalhost) {
        await logToDatabase('LogInfo', message, false, "");
    }
}

export const logWarningToDatabase = async (message: string) => {
    var errorMessage = message.toString();
    if ((!errorMessage.startsWith("\"Warning: <BrowserRouter> ignores the history prop.")) &&
        (!errorMessage.startsWith("\"./src/components"))) {
        await logToDatabase('LogWarning', message, true, "");
    }
}

export const logErrorToDatabase = async (message: string) => {
    var error = new Error();
    var stack = error.stack + "";
    var errorMessage = message.toString();
    if (errorMessage.startsWith("\"") && errorMessage.endsWith("\"")) {
        errorMessage = errorMessage.slice(1,-1);
    }
    if (!ERROR_WHITELIST.some(substr => errorMessage.startsWith(substr))) {
        await logToDatabase('LogError', message, true, stack);
    }
}

export const logErrorToDatabaseWithStack = async (message: string, stack: string) => {
    await logToDatabase('LogError', message, true, stack);
}

export const logCriticalToDatabase = async (message: string) => {
    var error = new Error();
    var stack = error.stack + "";
    await logToDatabase('LogCritical', message, true, stack);
}

export const logCriticalToDatabaseWithStack = async (message: string, stack: string) => {
    await logToDatabase('LogCritical', message, true, stack);
}

const logToDatabase = async (endpoint: string, message: string, logState: boolean, stackTrace: string) => {
    var finalEndpoint = endpoint;
    if (isLocalhost) {
        finalEndpoint = '../' + endpoint;
    }
    var state = "";
    if (logState) {
        try {
            const reduxState = store.getState();
            state = JSON.stringify(reduxState);
        } catch (err) {
            state = "{Error getting state: " + err + "} "
        }
    }
    let jsonBody = JSON.stringify({
        Message: message,
        ReduxState: state,
        StackTrace: stackTrace,
    });
    try {
        await fetch(finalEndpoint, {
            method: 'POST',
            headers: {
                'Accept': 'application/json; charset=utf-8',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: jsonBody,
        }).catch((err) => {
            console.log("Error fetching log data: '" + finalEndpoint + "' Body: '" + jsonBody + "' Err: " + err);
        });
    } catch (err) {
        console.log("Error fetching log data: '" + finalEndpoint + "' Body: '" + jsonBody + "' Err: " + err);
    }
}